import styled from 'styled-components';
import { UnicodeEntity } from '@mews/enums';
import { getSpacingToken, getTextTokenPreset, getToken, VISUALLY_HIDDEN } from '@optimus-web/common';

interface FormLabelProps {
    children: React.ReactNode;
    required?: boolean;
    inline?: boolean;
    as?: React.ElementType;
    onClick?: () => void;
    htmlFor?: string;
    readOnly?: boolean;
    $disabled?: boolean;
    name?: string;
    id?: string;
}

type FormLabelElementProps = Pick<FormLabelProps, 'inline' | 'readOnly' | '$disabled'>;

export const getColor = (props: FormLabelElementProps) => {
    if (props.$disabled) {
        return getToken('textDisabled');
    } else if (props.readOnly) {
        return getToken('textStaticSecondary');
    }

    return getToken('textStaticPrimary');
};

export const FormLabelElement = styled.label<FormLabelElementProps>`
    ${getTextTokenPreset('bodyMediumStrong')};
    color: ${getColor};
    ${({ inline }) => inline && VISUALLY_HIDDEN}
`;

export const Asterisk = styled.span<{ readOnly?: boolean; $disabled?: boolean }>`
    ${getTextTokenPreset('bodyMediumStrong')};
    padding-left: ${getSpacingToken('50')}px;
    color: ${getColor};
`;

export const makeLabelId = (name: string) => `${name}-label`;

export const FormLabel = ({ children, $disabled, required, readOnly, name, ...other }: FormLabelProps) => (
    <FormLabelElement $disabled={$disabled} readOnly={readOnly} {...(name ? { id: makeLabelId(name) } : {})} {...other}>
        {children}
        {required ? (
            <Asterisk $disabled={$disabled} readOnly={readOnly} aria-hidden>
                {UnicodeEntity.Asterisk}
            </Asterisk>
        ) : null}
    </FormLabelElement>
);
